import { render, staticRenderFns } from "./SupplierDocument.vue?vue&type=template&id=83cb9e04&"
import script from "./SupplierDocument.vue?vue&type=script&lang=js&"
export * from "./SupplierDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports